/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type EditNewslettersInput = {
    readonly userServiceId: string;
    readonly emailToken?: string | null;
    readonly promotional?: unknown | null;
    readonly favoriteSearches?: unknown | null;
    readonly favoriteDealers?: unknown | null;
    readonly trade?: unknown | null;
    readonly smsOptin?: unknown | null;
    readonly orderFeedbackMailOptin?: unknown | null;
    readonly clientMutationId?: string | null;
};
export type subscribeUserMutationVariables = {
    readonly input: EditNewslettersInput;
};
export type subscribeUserMutationResponse = {
    readonly editNewsletters: {
        readonly clientMutationId: string | null;
    } | null;
};
export type subscribeUserMutation = {
    readonly response: subscribeUserMutationResponse;
    readonly variables: subscribeUserMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "EditNewslettersInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "editNewsletters",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "EditNewslettersPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "clientMutationId",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "subscribeUserMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "subscribeUserMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "subscribeUserMutation",
            "id": "ferrum/234.0.0-2019-09-20T21:19:24.316Z/subscribeUserMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'c9543e77c781df16904396e3a1064187';
export default node;
